import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import OrganizationLayout from "../layouts/ClientLayout";

import Dashboard from "../pages/organization/Dashboard";
import Users from "../pages/organization/Users";
import Brands from "../pages/organization/Brands";
import Templates from "../pages/organization/Templates";
import Creatives from "../pages/organization/Creatives";
import Campaigns from "../pages/organization/Campaigns";
import XMLTester from "../pages/organization/XMLTester";
import Profile from "../pages/public/Profile";
import ChangePassword from "../pages/public/ChangePassword";
import Editor from "../pages/organization/Editor";
import QRDesigner from "../pages/organization/QREditor";
import Subscription from "../pages/organization/Subscription";
import Plans from "../pages/organization/Plan";

export default function OrganizationRoutes() {
  return (
    <Route
      path="/organization"
      element={
        <ProtectedRoute roles={["organization"]}>
          <OrganizationLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Dashboard />} />
      <Route path="campaigns" element={<Campaigns />} />
      <Route path="users" element={<Users />} />
      <Route path="brands" element={<Brands />} />
      <Route path="creatives" element={<Creatives />} />
      <Route path="templates" element={<Templates />} />
      <Route path="editor" element={<Editor />} />
      <Route path="xml-tester" element={<XMLTester />} />
      <Route path="qr-generator" element={<QRDesigner />} />
      <Route path="profile" element={<Profile />} />
      <Route path="change-password" element={<ChangePassword />} />
      <Route path="subscription" element={<Subscription />} />
      <Route path="plans" element={<Plans />} />
    </Route>
  );
}